import { useState } from "react";
import expertImage from "./assets/expert.jpg";

const REGISTRATION_LINK = "https://tally.so/r/Y5roBd";
const LINKEDIN_LINK = "https://www.linkedin.com/in/anett-horv%C3%A1th-5465342a4/";
const INSTAGRAM_LINK = "https://instagram.com/horvathanettii";

function App() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email && name) {
      setSubmitted(true);
    }
  };

  return (
    <div className="min-h-screen font-sans bg-[#0A0A0A] text-white">
      {/* HERO SECTION */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Subtle background pattern */}
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(circle_at_1px_1px,#fff_1px,transparent_0)] bg-[length:40px_40px]"></div>
        
        <div className="relative z-10 max-w-6xl mx-auto px-6 py-20">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left - Text */}
            <div className="text-left">
              <div className="mb-6">
                <span className="inline-block px-4 py-2 border border-white/20 text-xs tracking-[0.2em] uppercase text-white/60">
                  Exkluzív online esemény
                </span>
              </div>
              
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-light tracking-tight mb-6 leading-[1.1]">
                Fegyelem vagy <span className="text-white">szabadság?</span>
              </h1>
              
              <p className="text-xl sm:text-2xl text-white/70 font-light mb-4 leading-relaxed">
                Nem minden adórendszer egyforma. Az egyik korlátoz. A másik skáláz.
              </p>
              
              <p className="text-lg text-white/50 mb-10 leading-relaxed max-w-md">
                Tudd meg, melyik modell hagy több pénzt a cégedben és ad nagyobb mozgásteret a növekedéshez.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <a
                  href={REGISTRATION_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center px-8 py-4 bg-white text-black text-lg font-medium tracking-wide hover:bg-white/90 transition-all duration-300"
                >
                  Jelentkezem az eseményre
                </a>
              </div>
              
              <div className="flex items-center gap-3 text-white/40 text-sm">
                <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
                <span>Limitált helyek</span>
                <span className="mx-2">•</span>
                <span>2026.06.05. 19:00 | Online esemény</span>
              </div>
            </div>
            
            {/* Right - Expert Image */}
            <div className="relative">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={expertImage}
                  alt="Horváth Anett"
                  className="w-full h-full object-cover grayscale contrast-[1.05]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              </div>
              <div className="absolute -bottom-6 -left-6 w-full h-full border border-white/10"></div>
            </div>
          </div>
        </div>
      </section>

      {/* PROBLEM / PAIN SECTION */}
      <section className="py-24 bg-[#0D0D0D]">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-xs tracking-[0.3em] uppercase text-white/40">A probléma</span>
            <h2 className="text-3xl sm:text-4xl font-light mt-4 leading-tight">
              A rendszer, amiben működsz, meghatározza a <span className="text-white">plafonodat</span>
            </h2>
          </div>
          
          <div className="grid gap-6">
            <div className="border-l-2 border-red-500/50 pl-8 py-2">
              <p className="text-xl text-white/70 font-light">
                Túl magas adóterhelés <span className="text-white">lassítja a növekedést</span>
              </p>
            </div>
            <div className="border-l-2 border-white/10 pl-8 py-2">
              <p className="text-xl text-white/70 font-light">
                A struktúra, amit használsz, <span className="text-white">korlátozza a lehetőségeidet</span>
              </p>
            </div>
            <div className="border-l-2 border-red-500/50 pl-8 py-2">
              <p className="text-xl text-white/70 font-light">
                Rossz struktúra <span className="text-white">elveszett profit</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* VISUAL DIRECTION - Split Layout */}
      <section className="grid lg:grid-cols-2 min-h-screen">
        {/* Hungary - Red */}
        <div className="bg-[#1a0a0a] py-24 px-6 lg:px-16 flex flex-col justify-center">
          <div className="max-w-md">
            <div className="w-12 h-1 bg-red-600 mb-8"></div>
            <span className="text-xs tracking-[0.3em] uppercase text-red-400/60">Magyar modell</span>
            <h3 className="text-4xl font-light mt-4 mb-6 text-white">
              Fegyelem
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-white/60">
                <span className="w-1.5 h-1.5 bg-red-500 rounded-full mt-2 shrink-0"></span>
                <span className="font-light">Bürokrácia és adminisztráció</span>
              </li>
              <li className="flex items-start gap-3 text-white/60">
                <span className="w-1.5 h-1.5 bg-red-500 rounded-full mt-2 shrink-0"></span>
                <span className="font-light">Magas adóterhelés</span>
              </li>
              <li className="flex items-start gap-3 text-white/60">
                <span className="w-1.5 h-1.5 bg-red-500 rounded-full mt-2 shrink-0"></span>
                <span className="font-light">Korlátozott skálázhatóság</span>
              </li>
              <li className="flex items-start gap-3 text-white/60">
                <span className="w-1.5 h-1.5 bg-red-500 rounded-full mt-2 shrink-0"></span>
                <span className="font-light">Döntési rugalmatlanság</span>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Estonia - Blue */}
        <div className="bg-[#0a1a2a] py-24 px-6 lg:px-16 flex flex-col justify-center">
          <div className="max-w-md">
            <div className="w-12 h-1 bg-blue-500 mb-8"></div>
            <span className="text-xs tracking-[0.3em] uppercase text-blue-400/60">Észt modell</span>
            <h3 className="text-4xl font-light mt-4 mb-6 text-white">
              Szabadság
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-white/60">
                <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 shrink-0"></span>
                <span className="font-light">Digitális, egyszerű adminisztráció</span>
              </li>
              <li className="flex items-start gap-3 text-white/60">
                <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 shrink-0"></span>
                <span className="font-light">Versenyképes adószabályozás</span>
              </li>
              <li className="flex items-start gap-3 text-white/60">
                <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 shrink-0"></span>
                <span className="font-light">Skálázható vállalati struktúra</span>
              </li>
              <li className="flex items-start gap-3 text-white/60">
                <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 shrink-0"></span>
                <span className="font-light">Stratégiai döntési szabadság</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* VALUE / OUTCOME SECTION */}
      <section className="py-24 bg-[#0D0D0D]">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-xs tracking-[0.3em] uppercase text-white/40">Az érték</span>
            <h2 className="text-3xl sm:text-4xl font-light mt-4 leading-tight">
              Amit <span className="text-white">megtudsz</span>
            </h2>
          </div>
          
          <div className="grid sm:grid-cols-2 gap-8">
            <div className="p-8 border border-white/10 hover:border-white/20 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center mb-4 text-2xl">
                <span className="text-blue-400">01</span>
              </div>
              <h4 className="text-lg font-light mb-2 text-white">Pénzmegmaradás</h4>
              <p className="text-white/50 font-light text-sm">
                Hol marad több pénz a cégedben, konkrét példákkal
              </p>
            </div>
            
            <div className="p-8 border border-white/10 hover:border-white/20 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center mb-4 text-2xl">
                <span className="text-blue-400">02</span>
              </div>
              <h4 className="text-lg font-light mb-2 text-white">Skálázhatóság</h4>
              <p className="text-white/50 font-light text-sm">
                Melyik rendszer támogatja a növekedést
              </p>
            </div>
            
            <div className="p-8 border border-white/10 hover:border-white/20 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center mb-4 text-2xl">
                <span className="text-blue-400">03</span>
              </div>
              <h4 className="text-lg font-light mb-2 text-white">Döntési szabadság</h4>
              <p className="text-white/50 font-light text-sm">
                Hogyan hat az adózás a céged irányítására
              </p>
            </div>
            
            <div className="p-8 border border-white/10 hover:border-white/20 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center mb-4 text-2xl">
                <span className="text-blue-400">04</span>
              </div>
              <h4 className="text-lg font-light mb-2 text-white">Vagyonépítés</h4>
              <p className="text-white/50 font-light text-sm">
                Melyik modell segít hosszú távon vagyont építeni
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* AUTHORITY SECTION - Enhanced with Horváth Anett */}
      <section className="py-24 bg-[#0A0A0A]">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="w-20 h-20 mx-auto mb-8 overflow-hidden rounded-full border-2 border-white/20">
            <img
              src={expertImage}
              alt="Horváth Anett"
              className="w-full h-full object-cover grayscale"
            />
          </div>
          <span className="text-xs tracking-[0.3em] uppercase text-white/40">Az előadást</span>
          <h3 className="text-2xl font-light mt-4 mb-2 text-white leading-relaxed">
            Horváth Anett tartja.
          </h3>
          <p className="text-white/60 font-light leading-relaxed mt-6 mb-6">
            Stratégiai szemléletben gondolkodom és vállalkozások működésének, skálázásának és nemzetközi struktúráinak optimalizálásával foglalkozom.
          </p>
          <p className="text-white/50 font-light text-sm leading-relaxed">
            A fókusz nem pusztán az információn van, hanem azon, hogyan hozol jobb döntéseket és hogyan építesz hatékonyabb rendszert.
          </p>
          <div className="w-12 h-px bg-white/20 mx-auto mt-8"></div>
        </div>
      </section>

      {/* FINAL CTA SECTION */}
      <section id="register" className="py-24 bg-[#0D0D0D]">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <h2 className="text-3xl sm:text-4xl font-light mb-4 leading-tight">
            Döntés előtt állsz, legyen mögötte <span className="text-white">stratégia</span>.
          </h2>
          <p className="text-white/50 mb-10 font-light">
            Ne maradj le a lehetőségről, ami megváltoztathatja a vállalkozásod jövőjét.
          </p>
          
          {submitted ? (
            <div className="p-8 border border-green-500/30 bg-green-500/5">
              <p className="text-green-400 font-light text-lg">Köszönjük a jelentkezést!</p>
              <p className="text-white/60 text-sm mt-2">Hamarosan keressük a megadott elérhetőségen.</p>
              
              {/* Connection CTAs on Thank You */}
              <div className="mt-8 pt-8 border-t border-green-500/20">
                <p className="text-white/70 font-light mb-4">Kapcsolódjunk</p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <a
                    href={LINKEDIN_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-6 py-3 border border-white/20 text-white/80 hover:bg-white/5 transition-all duration-300 font-light text-sm"
                  >
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                    Kapcsolódjunk LinkedInen
                  </a>
                  <a
                    href={INSTAGRAM_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-6 py-3 border border-white/20 text-white/80 hover:bg-white/5 transition-all duration-300 font-light text-sm"
                  >
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                    </svg>
                    Kövess Instagramon
                  </a>
                </div>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="text"
                placeholder="Név"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full px-6 py-4 bg-transparent border border-white/20 text-white placeholder-white/40 focus:border-white/50 focus:outline-none transition-colors font-light"
                required
              />
              <input
                type="email"
                placeholder="Email cím"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-6 py-4 bg-transparent border border-white/20 text-white placeholder-white/40 focus:border-white/50 focus:outline-none transition-colors font-light"
                required
              />
              <a
                href={REGISTRATION_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full inline-flex items-center justify-center px-8 py-4 bg-white text-black text-lg font-medium tracking-wide hover:bg-white/90 transition-all duration-300"
              >
                Jelentkezem most
              </a>
            </form>
          )}
          
          <div className="mt-8 flex items-center justify-center gap-3 text-red-400 text-sm">
            <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
            <span>Ne maradj le</span>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-8 bg-[#050505] border-t border-white/5">
        <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-sm font-light">
            © 2026. Minden jog fenntartva.
          </p>
          <div className="flex items-center gap-6">
            <a
              href={LINKEDIN_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/30 hover:text-white/50 transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a
              href={INSTAGRAM_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/30 hover:text-white/50 transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
